import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle, Home, RefreshCw } from 'lucide-react';

const PaymentCancelPage = () => {
  const [params] = useSearchParams();
  const ref = params.get('ref') || '';

  return (
    <div className="min-h-screen bg-gradient-to-br from-cream via-white to-cream flex items-center justify-center p-4">
      <Card className="w-full max-w-lg p-10 bg-white shadow-2xl text-center" data-testid="payment-cancel-card">
        <div className="inline-flex p-4 bg-red-100 rounded-full mb-4">
          <XCircle className="text-red-600" size={56} />
        </div>
        <h1 className="text-3xl font-bold text-burgundy mb-2">Paiement annulé</h1>
        <p className="text-slate-600 mb-6">
          Vous avez annulé le paiement. Aucune somme n'a été débitée.
        </p>
        {ref && (
          <p className="text-xs font-mono text-slate-400 mb-6" data-testid="cancel-ref">
            Référence : {ref}
          </p>
        )}
        <div className="space-y-3">
          <Link to="/produits" className="block">
            <Button size="lg" className="w-full bg-burgundy hover:bg-burgundy-dark" data-testid="retry-btn">
              <RefreshCw size={18} className="mr-2" />
              Réessayer la commande
            </Button>
          </Link>
          <Link to="/" className="block">
            <Button variant="outline" size="lg" className="w-full" data-testid="back-home-btn">
              <Home size={18} className="mr-2" />
              Retour à l'accueil
            </Button>
          </Link>
        </div>
      </Card>
    </div>
  );
};

export default PaymentCancelPage;
